"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAdditionalFields = exports.sanitiseColor = void 0;
const sanitiseColor = (color) => {
    if (color.includes("#"))
        return color;
    return "#" + color;
};
exports.sanitiseColor = sanitiseColor;
const extractAdditionalFields = (additionalFields) => {
    if (!additionalFields)
        return {};
    const pairs = additionalFields.split("_");
    const result = {};
    pairs.forEach((pair) => {
        const [key, value] = pair.split("~");
        const formattedKey = key === null || key === void 0 ? void 0 : key.replace(/!2D/g, "");
        const formattedValue = value === null || value === void 0 ? void 0 : value.replace(/!2E/g, ".").replace(/!2D/g, "-").replace(/!7E/g, "~").replace(/!5F/g, "_");
        if (!formattedKey || !formattedValue)
            return;
        result[formattedKey] = formattedValue;
    });
    return result;
};
exports.extractAdditionalFields = extractAdditionalFields;
